import React, { forwardRef, useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import ReactRelativeTime from "react-relative-time";
import axios from 'axios';
import { getAuth } from 'firebase/auth';

import "../App.css";
import { toast } from 'react-toastify';

const Notification = forwardRef(({ data, setUnReadCount }, ref) => {
    const navigate = useNavigate();
    const [expandId, setExpandId] = useState(false);
    const [notificationData, setNotificationData] = useState(data);

    const auth = getAuth();

    useEffect(() => {
        // Calculate the unread count when data changes
        if (data && data.result && data.result.results) {
            setUnReadCount(data.result.unRead_count);
        }
    }, [data, setUnReadCount]);
    
    //display day date (dd/mm) time (10:35) 
    const formatDate = (date) => {
        let d = new Date(date);
        let day = d.getDate().toString().padStart(2, '0');
        let month = (d.getMonth() + 1).toString().padStart(2, '0');
        let hour = d.getHours().toString().padStart(2, "0");
        let minutes = d.getMinutes().toString().padStart(2, "0");
        return `${day}/${month} ${hour}:${minutes}`;
    };
    
    const handleShowMore = (id) => {
        setExpandId(expandId == id ? null : id);
        //after expand can send a request to update isRead = true
    };

    //get token
    const getToken = async () => {
        try {
            const currentUser = auth.currentUser;
            if(currentUser) {
                return await currentUser.getIdToken(true);
            }
        } catch (error) {
            console.log("Error fetching token:", error);
            return null;
        }
    };

    const handleClick = () => {
        const dataToPass = data;
        navigate("/notifications", { state: dataToPass });
    }

    const fetchNotifications = async () => {
        try {
            const token = await getToken();
            if(!token) return;

            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/notification`, {
                params: {
                    skip: 0,
                    limit: 10
                },
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            });
            
            if(response.data) {
                setNotificationData(response.data)
                setUnReadCount(response.data.result.unRead_count)
            } else {
                setNotificationData(null)
                setUnReadCount(0)
            }
            
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const markAllAsRead = async () => {
        try {
            const token = await getToken();
            if(!token) return;

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/notification/read`,
                {},
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if(response.data.success) {
                toast.success("Notification updated successfully");
                setUnReadCount(0);
                fetchNotifications();
            } else {
                toast.info("updating");
            }
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <>
            <div ref={ref} className="notification_dd">
                <ul className="notification_ul">
                    <div className="notification_header">
                        Notifications
                        <span className="readAll" onClick={markAllAsRead}>Mark all as read</span>
                    </div>
                    {notificationData && notificationData.result.results && notificationData.result.results.length > 0 ? (
                        notificationData.result.results.map((i) => (
                            <li key={i.notification_id}>
                                <div className="notify_icon">
                                    <span className="icon">
                                        {/* <img className='icon_img' src={i.user_icon} alt='icon' /> */}
                                    </span>
                                </div>
                                <div className={expandId == i.id ? "notify_data_show_all" : "notify_data"}>
                                    <span className="notification_title">
                                        {i.notification_type.replace("_", " ")}
                                    </span>
                                    <span className="notification_sub_title">
                                        &nbsp;{i.notification_content}
                                    </span>
                                    <div className="notification_status">
                                        {i.is_read ? <div></div> : <div className="notify_status"></div>}
                                        <div className="notify_status_time"><ReactRelativeTime value={i.created_dtm} /></div>&nbsp;
                                        {/* <div className="notify_status_time">{formatDate(i.created_dtm)}</div>&nbsp; */}
                                        {/* <div className="notify_show_more" onClick={() => handleShowMore(i.notification_id)}>
                                            {expandId == i.notification_id ? "Show Less" : "Show More"}
                                        </div> */}
                                    </div>
                                </div>
                            </li>
                        ))
                    ): (
                        <div className='App'>No data found</div>
                    )}
                    <li className="show_all">
                        <a onClick={handleClick}>
                            <p>Show Previous Notification</p>
                        </a>
                    </li>
                </ul>
            </div>
        </>
    )
});

export default Notification
